var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentCard = function SvgPaymentCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/outline/payment card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fill: "#1F1E1F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.15 7.5A1.15 1.15 0 0 0 19 6.35H5A1.15 1.15 0 0 0 3.85 7.5v10c0 .635.515 1.15 1.15 1.15h14a1.15 1.15 0 0 0 1.15-1.15zm1.7 10A2.85 2.85 0 0 1 19 20.35H5a2.85 2.85 0 0 1-2.85-2.85v-10A2.85 2.85 0 0 1 5 4.65h14a2.85 2.85 0 0 1 2.85 2.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.15a.85.85 0 1 1 0 1.7H3a.85.85 0 1 1 0-1.7zM9 14.1a.9.9 0 0 1 0 1.8H7a.9.9 0 0 1 0-1.8z"
  })))));
};
export default SvgPaymentCard;